import { type Elastic } from '@vakantiesnl/types/src';

export const getSubscores = (
	reviewPerAspectGroup: Partial<Elastic.PerAspectGroup>,
): { rating: number; label: string }[] | [] => {
	if (typeof reviewPerAspectGroup === 'object' && reviewPerAspectGroup !== null) {
		return (
			Object.keys(reviewPerAspectGroup)
				.map((key: string) => ({
					rating: reviewPerAspectGroup[key as keyof Elastic.PerAspectGroup]?.rating as number,
					label: key,
				}))
				.filter((item) => item.rating !== undefined && item.label !== 'general') || []
		);
	} else {
		return [];
	}
};
